/**
 * Lectura de variables de entorno (RF-DEV-05).
 *
 * Regla de seguridad (RNF-06): solo llegan al cliente las variables con
 * prefijo `VITE_`. La clave de servicio de Supabase no aparece aqui ni puede
 * aparecer: vive unicamente en las Edge Functions.
 */

import type { Language } from '@/types/domain';

function readString(value: unknown, fallback = ''): string {
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
}

const supabaseUrl = readString(import.meta.env.VITE_SUPABASE_URL);
const supabaseAnonKey = readString(import.meta.env.VITE_SUPABASE_ANON_KEY);
const forcedDemo = readString(import.meta.env.VITE_DEMO_MODE).toLowerCase() === 'true';

export const env = {
  supabaseUrl,
  supabaseAnonKey,
  siteUrl: readString(import.meta.env.VITE_SITE_URL, 'http://localhost:5173'),
  defaultLanguage: readString(import.meta.env.VITE_DEFAULT_LANGUAGE, 'es') as Language,
  vapidPublicKey: readString(import.meta.env.VITE_VAPID_PUBLIC_KEY),
  plausibleDomain: readString(import.meta.env.VITE_PLAUSIBLE_DOMAIN),
  sentryDsn: readString(import.meta.env.VITE_SENTRY_DSN),

  /**
   * Sin credenciales de Supabase la aplicacion arranca con datos de ejemplo
   * en el navegador. Asi `npm install && npm run dev` ensena la interfaz
   * completa sin configurar nada (RF-DEV-02).
   */
  isDemoMode: forcedDemo || !supabaseUrl || !supabaseAnonKey,

  /**
   * Direccion del panel de administracion, que es una aplicacion aparte.
   *
   * En produccion se pone el subdominio real (`https://admin.tudominio.com`).
   * Sin configurar vale `/admin.html`, que funciona tanto en desarrollo como
   * en un despliegue de un solo dominio: es un fichero de verdad y el servidor
   * lo sirve antes de aplicar la reescritura del enrutado.
   */
  adminUrl: readString(import.meta.env.VITE_ADMIN_URL, '/admin.html'),
} as const;

export const isProduction = import.meta.env.PROD;
